module.exports = __webpack_public_path__ + "static/img/hysteroscope-detail-4.2115ed8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/hysteroscopepic/hysteroscope-detail-4.jpg
// module id = c0F5
// module chunks = 51